import styled from 'styled-components'

export const DefaultTooltip = styled.div`
    position: absolute;
    width: 15.625rem;
    clip: rect(0,0,0,0);
    clip-path: inset(50%);
    padding: 1.5rem;
    background-color: #FFFFFF;
    box-shadow: 0 0.125rem 0.625rem 0 rgba(0,0,0,0.25);
    border-radius: 0.5rem;
    color: ${p => p.theme.colors.mediumGrey};
    font-size: 0.875rem;
    font-weight: 600;	
    line-height: 1.125rem;
    letter-spacing: -0.01rem;    

    ::before {
        content: '';
        position: absolute;
        left: -0.5rem;
        top: 40%;
        border: 0.5rem solid #fff;
        border-color: transparent transparent #fff #fff;
        transform: rotate(45deg);
        box-shadow: -0.1875rem 0.1875rem 0.1875rem -0.1875rem rgba(0,0,0,0.25);
    }
    
    // right
    left: 100%;
    margin-left: 1.25em;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    
}
`

export const TooltipWrap = styled.div`
  position: relative;
  contain: style layout;
  display: inline-block;
  line-height: 16px;

  svg {
    fill: #ababab;
  }

  :hover {
    outline: 0;
    pointer-events: auto;

    svg {
      fill: #3db8f1;
    }

    ${DefaultTooltip} {
      clip: auto;
      clip-path: none;
      pointer-events: auto;
      z-index: 1;
    }
  }
`
